export const RatingIcons = {
  heart: { value: 'heart', name: '❤️' },
  star: { value: 'star', name: '⭐' },
  thumb: { value: 'thumb', name: '👍' },
};



// WEBPACK FOOTER //
// ./src/models/survey/RatingIcons.js